import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class ProjectService {

    static getProjectListResult(CompanyCode, list, ActionType) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType: ActionType
        }  
        return axios.post( BaseUrl +'Project', data);
    }

    static SaveProject(CompanyCode, list, ActionType, email) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType: ActionType
        }  
        return axios.post(BaseUrl +'SaveProject?email='+email, data);
    }
}


// WEBPACK FOOTER //
// ./src/Services/ProjectService/projectService.js